// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbg_a bhn_i bhn_j","ColorVariants__color":"bbg_b bhn_rp","ColorVariants__more":"bbg_c bhn_vv"};